import { AUTH_STATE } from '../constants';

function clearLocalStorage() {
  localStorage.removeItem(AUTH_STATE);
}

export default clearLocalStorage;
